import styled from "styled-components";

export const StyledHeader = styled.div`
    width: 100%;
    height: 280px;
    background-image: url('images/pattern-bg.png');
    background-size: cover;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.3);
`;